import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {AgencyUser, CreateAgencyUserPhoneRequest} from "../../entities/AgencyUser.ts";

export class LinkAgencyUserPhoneUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, uid: string, data: CreateAgencyUserPhoneRequest): Promise<AgencyUser> {
        return this.agencyRepository.linkAgencyUserPhone(agencyId, uid, data)
    }
}
